import { createContext } from "react";
import { TabletopCanvasInputMode } from "./TabletopCanvasInputMode";
import { TabletopCanvasInputDomain } from "./TabletopCanvasInputDomain";
import ITabletopShapeRenderer from "../objects/element/shape_renderer/ITabletopShapeRenderer";

export type TabletopCanvasInputState = {
    inputDomain: TabletopCanvasInputDomain;
    inputMode: TabletopCanvasInputMode;
    palette: {
        terrainShape?: ITabletopShapeRenderer | null;
    };
};

export const DefaultCanvasInputState = {
    inputDomain: TabletopCanvasInputDomain.NAVIGATION,
    inputMode: TabletopCanvasInputMode.NAVIGATE_CANVAS,
    palette: {},
};

type TabletopCanvasInputContextValue = {
    state: TabletopCanvasInputState;
    setState: (newState: TabletopCanvasInputState) => void;
};

const TabletopCanvasInputContext =
    createContext<TabletopCanvasInputContextValue>({
        state: DefaultCanvasInputState,
        setState: (_) => {},
    });

export { TabletopCanvasInputContext };
